import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

type Params = Parameters<typeof apiClient.getCharmPrice>[0]["queries"];

export const useCharmPrice = (params: Params, options?: { enabled?: boolean }) => {
  return useQuery({
    queryKey: [{ entity: "charm_price", params }],
    queryFn: async () =>
      await apiClient.getCharmPrice({
        queries: params,
      }),
    ...options,
  });
};
